import { render } from "./CustomRadioButton.vue?vue&type=template&id=635e4cd8"
import script from "./CustomRadioButton.vue?vue&type=script&lang=js"
export * from "./CustomRadioButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__